import type { CoachingCoacheeCohortModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort';
import type { TOC } from '@ember/component/template-only';
import { array } from '@ember/helper';
import { LinkTo } from '@ember/routing';
import { pageTitle } from 'ember-page-title';

interface CoachingCoacheeCohortSessionsSignature {
  Args: {
    model: CoachingCoacheeCohortModel;
    controller: unknown;
  };
}

<template>
  {{pageTitle "Sessions"}}

  <div class="container my-3">
    <div
      class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4"
    >
      <ul
        class="nav nav-pills bg-body rounded-pill p-1 shadow-sm d-inline-flex"
      >
        <li class="nav-item">
          <LinkTo
            @route="coaching.coachee.cohort.sessions.index"
            @models={{array @model.program_id @model.cohort_id}}
            class="nav-link rounded-pill px-4 fw-semibold"
          >Current</LinkTo>
        </li>
        <li class="nav-item">
          <LinkTo
            @route="coaching.coachee.cohort.sessions.history"
            @models={{array @model.program_id @model.cohort_id}}
            class="nav-link rounded-pill px-4 fw-semibold"
          >History</LinkTo>
        </li>
      </ul>

      {{#if @model.planner.coachHasBeenChosen}}
        <div class="d-flex flex-wrap align-items-center gap-3">
          <div
            class="bg-body rounded-1 shadow-sm d-flex align-items-center gap-3 px-3 py-2"
          >
            <iconify-icon
              inline
              icon="ph:credit-card"
              class="text-primary fs-5"
              aria-hidden="true"
            />
            <div class="lh-1">
              <p class="gud-eyebrow mb-0 text-body-secondary">Credit balance</p>
              <span
                class="fw-bold small
                  {{unless
                    @model.planner.quota.coaching.remaining
                    'text-danger'
                  }}"
              >{{@model.planner.quota.coaching.remaining}}
                remaining</span>
            </div>
          </div>
          {{#let
            (@model.planner.chosenCoachPartnership)
            as |chosenCoachPartnership|
          }}
            {{#if chosenCoachPartnership}}
              {{#if
                (@model.planner.canBookCoachingSession
                  chosenCoachPartnership.coachUserId
                )
              }}
                <LinkTo
                  @route="coaching.coachee.cohort.sessions.book-session"
                  @models={{array @model.program_id @model.cohort_id}}
                  class="btn btn-primary"
                >
                  <iconify-icon
                    inline
                    icon="ph:calendar-plus"
                    aria-hidden="true"
                  />
                  Book session
                </LinkTo>
              {{/if}}
            {{/if}}
          {{/let}}
        </div>
      {{/if}}
    </div>
  </div>

  {{outlet}}
</template> satisfies TOC<CoachingCoacheeCohortSessionsSignature>;
